<template>
	<div>
		<header-pago />
		<status
			:img="`${$S3}waiting-1.svg`"
			text-one="ESTA SIENDO"
			text-two="PROCESADO"
		/>
		<section-help />
		<footer-pago />
	</div>
</template>
<script>
import headerPago from '@/components/pago/app-header';
import status from '@/components/pago/status';
import sectionHelp from '@/components/home/section-help';
import footerPago from '@/components/pago/footer-pago';

export default {
	name: 'page-pago-exitoso',
	components: {
		headerPago,
		status,
		sectionHelp,
		footerPago,
	},
};
</script>


// WEBPACK FOOTER //
// src/pages/page-pago-proceso.vue